import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-strategic-planning',
  templateUrl: './strategic-planning.component.html',
  styleUrls: ['./strategic-planning.component.scss']
})
export class StrategicPlanningComponent implements OnInit {

  yearly = true;

  constructor() { }

  ngOnInit(): void {
  }

}
